const Handlebars = require('handlebars');

/*
* jQuery Mapbox plugin
*/
;(function($) {
	function Mapbox(options) {
		this.options = $.extend({
			startZoom: 10
		}, options);

		this.init();
	}

	Mapbox.prototype = {
		init: function() {
			if (this.options.holder) {
				this.findElements();
				this.createMap();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function() {
			this.holder = $(this.options.holder);
			this.markersData = this.holder.data('markers');
			this.jsonData = this.holder.data('json');
			this.map = null;
			this.allMarkers = [];
		},
		createMap: function() {
			mapboxgl.accessToken = this.holder.data('token');

			const initMap = (data) => {
				const {markers} = data;

				this.map = new mapboxgl.Map({
					container: this.holder[0],
					style: this.holder.data('styles'),
					zoom: this.options.startZoom,
					center: this.holder.data('center')
				});

				this.map.scrollZoom.disable();

				this.prepareMarkers(markers);

				setTimeout(() => {
					this.makeCallback('onDataLoad', markers);
				}, 200);
			}

			if (this.markersData) {
				initMap(this.markersData);
			} else if (this.jsonData) {
				this.loadMarkers(this.jsonData, (data) => {
					initMap(data);
				});
			}
		},
		loadMarkers: function(url, complete) {
			fetch(url)
				.then((res) => res.json())
				.then((data) => {
					complete(data);
				});
		},
		prepareMarkers: function(data) {
			this.removeMarkers();

			const bounds = new mapboxgl.LngLatBounds();

			data.forEach((item) => {
				this.addMarker(item);
				bounds.extend(item.coordinates);
			});

			this.map.fitBounds(bounds, {
				maxZoom: 12,
				padding: 50
			});
		},
		addMarker: function(item) {
			const el = document.createElement('div');

			el.className = 'marker';

			const popupHTML = $(this.holder.data('popup-template')).html();
			const template = Handlebars.compile(popupHTML);

			const popup = new mapboxgl.Popup({
				offset: 20
			}).setHTML(template(item));

			const marker = new mapboxgl.Marker(el)
				.setLngLat(item.coordinates)
				.setPopup(popup)
				.addTo(this.map);

			this.allMarkers.push(marker);
		},
		removeMarkers: function() {
			this.allMarkers.forEach(function(item) {
				item.remove();
			});
		},
		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);

				args.shift();
				this.options[name].apply(this, args);
			}
		},
		destroy: function() {
			this.holder.removeData('Mapbox');
		}
	};

	// jQuery plugin interface
	$.fn.mapbox = function(opt) {
		return this.each(function() {
			$(this).data('Mapbox', new Mapbox($.extend(opt, {
				holder: this
			})));
		});
	};
}(jQuery));
